import { FC } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { Input } from '../Form/Input/input.component'
import { Button } from '../Form/Button/button.scomponent'

interface IForgotPasswordForm {
  username: string
}

const schema = Yup.object().shape({
  username: Yup.string().email('Informe um e-mail válido').required('E-mail obrigatório'),
})

interface IForgotPasswordModalProps {
  open: boolean
  loading?: boolean
  onClose: () => void
  onSubmit: (username: string) => void
}

export const ForgotPasswordModal: FC<IForgotPasswordModalProps> = ({
  open,
  loading = false,
  onClose,
  onSubmit,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IForgotPasswordForm>({
    resolver: yupResolver(schema),
    defaultValues: { username: '' },
  })

  const handleClose = () => {
    reset()
    onClose()
  }

  const submit = handleSubmit(({ username }) => {
    onSubmit(username.trim())
  })

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography fontSize="22px" fontWeight={700}>
          Recuperar senha
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Informe seu e-mail de acesso. Se existir uma conta cadastrada, enviaremos instruções para redefinir a senha.
        </DialogContentText>
        <Input
          label="E-mail"
          placeholder="seu.email@papello.com.br"
          autoComplete="email"
          error={!!errors.username}
          helperText={errors.username?.message}
          disabled={loading}
          {...register('username')}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="text" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={submit} isLoading={loading}>
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
